export enum StopTypes {
  Pickup = 1,
  Delivery = 2,
}
